module.exports = "/_next/static/images/coupon-logo-8b99aa8df21655d2e37cd17cfc5af7fc.png";